export enum LocalStorageItem {
  USER_ID = 'memberId',
  NAVBAR_COLLAPSED = 'navbarCollapsed',
  FILTER_COLLAPSED = 'filterCollapsed',
  SORT_BY = 'sortBy',
  ASCENDING = 'ascending',
  NO_COVERAGE = 'noCoverage',
  LEAD_INSURER_NEEDED = 'leadInsurerNeeded',
  FOLLOWING_INSURER_NEEDED = 'followingInsurerNeeded',
  LIMIT_PRICE = 'limitPrice',
  SELECTED_ROLE = 'selectedRole',
  LINE_OF_BUSINESS = 'lineOfBusiness',
  ARE_OPENED_LOGIN_DIALOGS = 'areOpenedLoginDialogs',
}
